import React from 'react';
import { CreateBlogProvider } from 'contexts/create-blog.context';
import CreateBlogContent from './content';
const CreateBlogLayout = () => {
  return (
    <CreateBlogProvider>
      <CreateBlogContent />
    </CreateBlogProvider>
  );
};

export default CreateBlogLayout;
